import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import type { StageResponse } from "~types/stage.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectStage = ({ value, ...props }: Props) => {
  const { sport, organizationId, seasonId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: StageResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.stageCode }));

  return (
    <InfinitySelect<StageResponse>
      {...props}
      url={`${sport}/o/${organizationId}/seasons/${seasonId}/stages`}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.STAGE}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
